<div class="t-{{activeTheme.theme}}">
  <mat-toolbar id="toolbar" class="toolbar" color="primary">
    <p class="textToolbar">
      {{terminalName}}
    </p>
    <span class="app-toolbar-filler"></span>
    <button mat-button class="buttonIcon" toggleFullscreen>
      <i class="material-icons iconBig">fullscreen</i>
    </button>
    <button mat-button class="buttonIcon" (click)="openSettings()">
      <i class="material-icons iconSettings">settings</i>
    </button>
  </mat-toolbar>

  <div class="app-content" id="content" (click)="toggleToolbar()">
    <div class="workerInfo" *ngIf="getShowWorkerBackground() && getCiCoTriggeringWorker() && getCiCoTriggeringWorker().userBackground">
      <img id="workerBackground" class="workerBackground"
           [src]="getCiCoTriggeringWorker().userBackground.safeSrc"
           [@workerState]="getCiCoTriggeringWorker().apiData.stateA">
    </div>
    <app-workers id="workers" class="workers" [showAbsent]="false"></app-workers>
    <app-workers id="absentWorkers" class="workers absent" [showAbsent]="true"></app-workers>
    <div id="messageBlock" class="messageBlock primary">
      <div class="textMessage" [hidden]="!infoMessage.messageShow">
        {{infoMessage.message | translate }}
      </div>
      <div id="subTextMessage" class="subTextMessage">
        <div [hidden]="!infoMessage.workTimeShow">
          {{ "WORK_TIME" | translate }}: {{infoMessage.workTime}}
        </div>
        <div [hidden]="!infoMessage.breakTimeShow">
          {{ "BREAK_TIME" | translate }}: {{infoMessage.breakTime}}
        </div>
        <div [hidden]="!infoMessage.todoTimeShow">
          {{ "TO_DO" | translate }}: {{infoMessage.todoTime}}
        </div>
      </div>
      <div [hidden]="!offlineS.offline">
        offline
      </div>
    </div>
    <div id="timeBlock" class="timeBlock">
      <div class="timeCorrect">
        <div id="dateSmall" class="dateSmall"> {{ out }}</div>
        <div>{{ aTime | date : 'HH:mm'}}</div>
      </div>
    </div>
  </div>
  <input class="rfidInput" id="rfidInput" autocomplete="off" autofocus (keyup.enter)="enterPress()">
</div>
